module.exports = __webpack_public_path__ + "static/img/right-bottom-row-6.9288dff5.png";